/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CreateWorkspaceRouteImport } from './routes/create-workspace'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as WWorkspaceRouteImport } from './routes/w.$workspace'
import { Route as WWorkspaceIndexRouteImport } from './routes/w.$workspace.index'
import { Route as WWorkspaceAutomationsRouteImport } from './routes/w.$workspace.automations'
import { Route as WWorkspaceCampaignsRouteImport } from './routes/w.$workspace.campaigns'
import { Route as WWorkspaceCommentsRouteImport } from './routes/w.$workspace.comments'
import { Route as WWorkspaceContactsRouteImport } from './routes/w.$workspace.contacts'
import { Route as WWorkspaceGettingStartedRouteImport } from './routes/w.$workspace.getting-started'
import { Route as WWorkspaceHandoversRouteImport } from './routes/w.$workspace.handovers'
import { Route as WWorkspaceInboxRouteImport } from './routes/w.$workspace.inbox'
import { Route as WWorkspaceOverviewRouteImport } from './routes/w.$workspace.overview'
import { Route as WWorkspaceReportsRouteImport } from './routes/w.$workspace.reports'
import { Route as WWorkspaceSettingsRouteImport } from './routes/w.$workspace.settings'
import { Route as WWorkspaceAutomationsIndexRouteImport } from './routes/w.$workspace.automations.index'
import { Route as WWorkspaceAutomationsAutomationIdRouteImport } from './routes/w.$workspace.automations.$automationId'
import { Route as WWorkspaceAutomationsModerationRouteImport } from './routes/w.$workspace.automations.moderation'
import { Route as WWorkspaceAutomationsNewRouteImport } from './routes/w.$workspace.automations.new'
import { Route as WWorkspaceAutomationsRunsRouteImport } from './routes/w.$workspace.automations.runs'
import { Route as WWorkspaceAutomationsTemplatesRouteImport } from './routes/w.$workspace.automations.templates'
import { Route as WWorkspaceCampaignsIndexRouteImport } from './routes/w.$workspace.campaigns.index'
import { Route as WWorkspaceCampaignsCampaignIdRouteImport } from './routes/w.$workspace.campaigns.$campaignId'
import { Route as WWorkspaceChannelsConnectionIdRouteImport } from './routes/w.$workspace.channels.$connectionId'
import { Route as WWorkspaceChannelsNewRouteImport } from './routes/w.$workspace.channels.new'
import { Route as WWorkspaceContactsIndexRouteImport } from './routes/w.$workspace.contacts.index'
import { Route as WWorkspaceContactsContactIdRouteImport } from './routes/w.$workspace.contacts.$contactId'
import { Route as WWorkspaceEnrolConversationIdRouteImport } from './routes/w.$workspace.enrol.$conversationId'
import { Route as WWorkspaceReleaseConversationIdRouteImport } from './routes/w.$workspace.release.$conversationId'
import { Route as WWorkspaceReportsIndexRouteImport } from './routes/w.$workspace.reports.index'
import { Route as WWorkspaceReportsAutomationsRouteImport } from './routes/w.$workspace.reports.automations'
import { Route as WWorkspaceReportsCampaignsRouteImport } from './routes/w.$workspace.reports.campaigns'
import { Route as WWorkspaceReportsSupportRouteImport } from './routes/w.$workspace.reports.support'
import { Route as WWorkspaceSettingsIndexRouteImport } from './routes/w.$workspace.settings.index'
import { Route as WWorkspaceSettingsAuditRouteImport } from './routes/w.$workspace.settings.audit'
import { Route as WWorkspaceSettingsChannelsRouteImport } from './routes/w.$workspace.settings.channels'
import { Route as WWorkspaceSettingsConsentRouteImport } from './routes/w.$workspace.settings.consent'
import { Route as WWorkspaceSettingsFieldsRouteImport } from './routes/w.$workspace.settings.fields'
import { Route as WWorkspaceSettingsGeneralRouteImport } from './routes/w.$workspace.settings.general'
import { Route as WWorkspaceSettingsModerationRouteImport } from './routes/w.$workspace.settings.moderation'
import { Route as WWorkspaceSettingsProfileRouteImport } from './routes/w.$workspace.settings.profile'
import { Route as WWorkspaceSettingsRolesRouteImport } from './routes/w.$workspace.settings.roles'
import { Route as WWorkspaceSettingsSavedRepliesRouteImport } from './routes/w.$workspace.settings.saved-replies'
import { Route as WWorkspaceSettingsTeamRouteImport } from './routes/w.$workspace.settings.team'
import { Route as WWorkspaceAutomationsAutomationIdIndexRouteImport } from './routes/w.$workspace.automations.$automationId.index'
import { Route as WWorkspaceAutomationsAutomationIdPublishRouteImport } from './routes/w.$workspace.automations.$automationId.publish'
import { Route as WWorkspaceAutomationsAutomationIdSimulateRouteImport } from './routes/w.$workspace.automations.$automationId.simulate'
import { Route as WWorkspaceAutomationsAutomationIdValidateRouteImport } from './routes/w.$workspace.automations.$automationId.validate'
import { Route as WWorkspaceAutomationsModerationIndexRouteImport } from './routes/w.$workspace.automations.moderation.index'
import { Route as WWorkspaceAutomationsModerationRuleIdRouteImport } from './routes/w.$workspace.automations.moderation.$ruleId'
import { Route as WWorkspaceAutomationsRunsIndexRouteImport } from './routes/w.$workspace.automations.runs.index'
import { Route as WWorkspaceAutomationsRunsRunIdRouteImport } from './routes/w.$workspace.automations.runs.$runId'
import { Route as WWorkspaceCampaignsCampaignIdIndexRouteImport } from './routes/w.$workspace.campaigns.$campaignId.index'
import { Route as WWorkspaceCampaignsCampaignIdAudienceRouteImport } from './routes/w.$workspace.campaigns.$campaignId.audience'
import { Route as WWorkspaceCampaignsCampaignIdMessageRouteImport } from './routes/w.$workspace.campaigns.$campaignId.message'
import { Route as WWorkspaceCampaignsCampaignIdRecipientsRouteImport } from './routes/w.$workspace.campaigns.$campaignId.recipients'
import { Route as WWorkspaceCampaignsCampaignIdResultsRouteImport } from './routes/w.$workspace.campaigns.$campaignId.results'
import { Route as WWorkspaceCampaignsCampaignIdReviewRouteImport } from './routes/w.$workspace.campaigns.$campaignId.review'
import { Route as WWorkspaceCampaignsCampaignIdScheduleRouteImport } from './routes/w.$workspace.campaigns.$campaignId.schedule'
import { Route as WWorkspaceChannelsConnectAttemptIdRouteImport } from './routes/w.$workspace.channels.connect.$attemptId'
import { Route as WWorkspaceContactsImportIndexRouteImport } from './routes/w.$workspace.contacts.import.index'
import { Route as WWorkspaceContactsSegmentsIndexRouteImport } from './routes/w.$workspace.contacts.segments.index'
import { Route as WWorkspaceContactsSegmentsSegmentIdRouteImport } from './routes/w.$workspace.contacts.segments.$segmentId'
import { Route as WWorkspaceContactsSegmentsNewRouteImport } from './routes/w.$workspace.contacts.segments.new'
import { Route as WWorkspaceSettingsModerationIndexRouteImport } from './routes/w.$workspace.settings.moderation.index'
import { Route as WWorkspaceSettingsModerationRuleIdRouteImport } from './routes/w.$workspace.settings.moderation.$ruleId'
import { Route as WWorkspaceContactsImportImportIdIndexRouteImport } from './routes/w.$workspace.contacts.import.$importId.index'
import { Route as WWorkspaceContactsImportImportIdReviewRouteImport } from './routes/w.$workspace.contacts.import.$importId.review'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateWorkspaceRoute = CreateWorkspaceRouteImport.update({
  id: '/create-workspace',
  path: '/create-workspace',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const WWorkspaceRoute = WWorkspaceRouteImport.update({
  id: '/w/$workspace',
  path: '/w/$workspace',
  getParentRoute: () => rootRouteImport,
} as any)
const WWorkspaceIndexRoute = WWorkspaceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WWorkspaceRoute,
} as any)
const WWorkspaceAutomationsRoute = WWorkspaceAutomationsRouteImport.update({
  id: '/automations',
  path: '/automations',
  getParentRoute: () => WWorkspaceRoute,
} as any)
const WWorkspaceCampaignsRoute = WWorkspaceCampaignsRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => WWorkspaceRoute,
} as any)
const WWorkspaceCommentsRoute = WWorkspaceCommentsRouteImport.update({
  id: '/comments',
  path: '/comments',
  getParentRoute: () => WWorkspaceRoute,
} as any)
const WWorkspaceContactsRoute = WWorkspaceContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => WWorkspaceRoute,
} as any)
const WWorkspaceGettingStartedRoute =
  WWorkspaceGettingStartedRouteImport.update({
    id: '/getting-started',
    path: '/getting-started',
    getParentRoute: () => WWorkspaceRoute,
  } as any)
const WWorkspaceHandoversRoute = WWorkspaceHandoversRouteImport.update({
  id: '/handovers',
  path: '/handovers',
  getParentRoute: () => WWorkspaceRoute,
} as any)
const WWorkspaceInboxRoute = WWorkspaceInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => WWorkspaceRoute,
} as any)
const WWorkspaceOverviewRoute = WWorkspaceOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => WWorkspaceRoute,
} as any)
const WWorkspaceReportsRoute = WWorkspaceReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => WWorkspaceRoute,
} as any)
const WWorkspaceSettingsRoute = WWorkspaceSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => WWorkspaceRoute,
} as any)
const WWorkspaceAutomationsIndexRoute =
  WWorkspaceAutomationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WWorkspaceAutomationsRoute,
  } as any)
const WWorkspaceAutomationsAutomationIdRoute =
  WWorkspaceAutomationsAutomationIdRouteImport.update({
    id: '/$automationId',
    path: '/$automationId',
    getParentRoute: () => WWorkspaceAutomationsRoute,
  } as any)
const WWorkspaceAutomationsModerationRoute =
  WWorkspaceAutomationsModerationRouteImport.update({
    id: '/moderation',
    path: '/moderation',
    getParentRoute: () => WWorkspaceAutomationsRoute,
  } as any)
const WWorkspaceAutomationsNewRoute =
  WWorkspaceAutomationsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => WWorkspaceAutomationsRoute,
  } as any)
const WWorkspaceAutomationsRunsRoute =
  WWorkspaceAutomationsRunsRouteImport.update({
    id: '/runs',
    path: '/runs',
    getParentRoute: () => WWorkspaceAutomationsRoute,
  } as any)
const WWorkspaceAutomationsTemplatesRoute =
  WWorkspaceAutomationsTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => WWorkspaceAutomationsRoute,
  } as any)
const WWorkspaceCampaignsIndexRoute =
  WWorkspaceCampaignsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WWorkspaceCampaignsRoute,
  } as any)
const WWorkspaceCampaignsCampaignIdRoute =
  WWorkspaceCampaignsCampaignIdRouteImport.update({
    id: '/$campaignId',
    path: '/$campaignId',
    getParentRoute: () => WWorkspaceCampaignsRoute,
  } as any)
const WWorkspaceChannelsConnectionIdRoute =
  WWorkspaceChannelsConnectionIdRouteImport.update({
    id: '/channels/$connectionId',
    path: '/channels/$connectionId',
    getParentRoute: () => WWorkspaceRoute,
  } as any)
const WWorkspaceChannelsNewRoute = WWorkspaceChannelsNewRouteImport.update({
  id: '/channels/new',
  path: '/channels/new',
  getParentRoute: () => WWorkspaceRoute,
} as any)
const WWorkspaceContactsIndexRoute = WWorkspaceContactsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WWorkspaceContactsRoute,
} as any)
const WWorkspaceContactsContactIdRoute =
  WWorkspaceContactsContactIdRouteImport.update({
    id: '/$contactId',
    path: '/$contactId',
    getParentRoute: () => WWorkspaceContactsRoute,
  } as any)
const WWorkspaceEnrolConversationIdRoute =
  WWorkspaceEnrolConversationIdRouteImport.update({
    id: '/enrol/$conversationId',
    path: '/enrol/$conversationId',
    getParentRoute: () => WWorkspaceRoute,
  } as any)
const WWorkspaceReleaseConversationIdRoute =
  WWorkspaceReleaseConversationIdRouteImport.update({
    id: '/release/$conversationId',
    path: '/release/$conversationId',
    getParentRoute: () => WWorkspaceRoute,
  } as any)
const WWorkspaceReportsIndexRoute = WWorkspaceReportsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WWorkspaceReportsRoute,
} as any)
const WWorkspaceReportsAutomationsRoute =
  WWorkspaceReportsAutomationsRouteImport.update({
    id: '/automations',
    path: '/automations',
    getParentRoute: () => WWorkspaceReportsRoute,
  } as any)
const WWorkspaceReportsCampaignsRoute =
  WWorkspaceReportsCampaignsRouteImport.update({
    id: '/campaigns',
    path: '/campaigns',
    getParentRoute: () => WWorkspaceReportsRoute,
  } as any)
const WWorkspaceReportsSupportRoute =
  WWorkspaceReportsSupportRouteImport.update({
    id: '/support',
    path: '/support',
    getParentRoute: () => WWorkspaceReportsRoute,
  } as any)
const WWorkspaceSettingsIndexRoute = WWorkspaceSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WWorkspaceSettingsRoute,
} as any)
const WWorkspaceSettingsAuditRoute = WWorkspaceSettingsAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => WWorkspaceSettingsRoute,
} as any)
const WWorkspaceSettingsChannelsRoute =
  WWorkspaceSettingsChannelsRouteImport.update({
    id: '/channels',
    path: '/channels',
    getParentRoute: () => WWorkspaceSettingsRoute,
  } as any)
const WWorkspaceSettingsConsentRoute =
  WWorkspaceSettingsConsentRouteImport.update({
    id: '/consent',
    path: '/consent',
    getParentRoute: () => WWorkspaceSettingsRoute,
  } as any)
const WWorkspaceSettingsFieldsRoute =
  WWorkspaceSettingsFieldsRouteImport.update({
    id: '/fields',
    path: '/fields',
    getParentRoute: () => WWorkspaceSettingsRoute,
  } as any)
const WWorkspaceSettingsGeneralRoute =
  WWorkspaceSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => WWorkspaceSettingsRoute,
  } as any)
const WWorkspaceSettingsModerationRoute =
  WWorkspaceSettingsModerationRouteImport.update({
    id: '/moderation',
    path: '/moderation',
    getParentRoute: () => WWorkspaceSettingsRoute,
  } as any)
const WWorkspaceSettingsProfileRoute =
  WWorkspaceSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => WWorkspaceSettingsRoute,
  } as any)
const WWorkspaceSettingsRolesRoute = WWorkspaceSettingsRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => WWorkspaceSettingsRoute,
} as any)
const WWorkspaceSettingsSavedRepliesRoute =
  WWorkspaceSettingsSavedRepliesRouteImport.update({
    id: '/saved-replies',
    path: '/saved-replies',
    getParentRoute: () => WWorkspaceSettingsRoute,
  } as any)
const WWorkspaceSettingsTeamRoute = WWorkspaceSettingsTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => WWorkspaceSettingsRoute,
} as any)
const WWorkspaceAutomationsAutomationIdIndexRoute =
  WWorkspaceAutomationsAutomationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WWorkspaceAutomationsAutomationIdRoute,
  } as any)
const WWorkspaceAutomationsAutomationIdPublishRoute =
  WWorkspaceAutomationsAutomationIdPublishRouteImport.update({
    id: '/publish',
    path: '/publish',
    getParentRoute: () => WWorkspaceAutomationsAutomationIdRoute,
  } as any)
const WWorkspaceAutomationsAutomationIdSimulateRoute =
  WWorkspaceAutomationsAutomationIdSimulateRouteImport.update({
    id: '/simulate',
    path: '/simulate',
    getParentRoute: () => WWorkspaceAutomationsAutomationIdRoute,
  } as any)
const WWorkspaceAutomationsAutomationIdValidateRoute =
  WWorkspaceAutomationsAutomationIdValidateRouteImport.update({
    id: '/validate',
    path: '/validate',
    getParentRoute: () => WWorkspaceAutomationsAutomationIdRoute,
  } as any)
const WWorkspaceAutomationsModerationIndexRoute =
  WWorkspaceAutomationsModerationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WWorkspaceAutomationsModerationRoute,
  } as any)
const WWorkspaceAutomationsModerationRuleIdRoute =
  WWorkspaceAutomationsModerationRuleIdRouteImport.update({
    id: '/$ruleId',
    path: '/$ruleId',
    getParentRoute: () => WWorkspaceAutomationsModerationRoute,
  } as any)
const WWorkspaceAutomationsRunsIndexRoute =
  WWorkspaceAutomationsRunsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WWorkspaceAutomationsRunsRoute,
  } as any)
const WWorkspaceAutomationsRunsRunIdRoute =
  WWorkspaceAutomationsRunsRunIdRouteImport.update({
    id: '/$runId',
    path: '/$runId',
    getParentRoute: () => WWorkspaceAutomationsRunsRoute,
  } as any)
const WWorkspaceCampaignsCampaignIdIndexRoute =
  WWorkspaceCampaignsCampaignIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WWorkspaceCampaignsCampaignIdRoute,
  } as any)
const WWorkspaceCampaignsCampaignIdAudienceRoute =
  WWorkspaceCampaignsCampaignIdAudienceRouteImport.update({
    id: '/audience',
    path: '/audience',
    getParentRoute: () => WWorkspaceCampaignsCampaignIdRoute,
  } as any)
const WWorkspaceCampaignsCampaignIdMessageRoute =
  WWorkspaceCampaignsCampaignIdMessageRouteImport.update({
    id: '/message',
    path: '/message',
    getParentRoute: () => WWorkspaceCampaignsCampaignIdRoute,
  } as any)
const WWorkspaceCampaignsCampaignIdRecipientsRoute =
  WWorkspaceCampaignsCampaignIdRecipientsRouteImport.update({
    id: '/recipients',
    path: '/recipients',
    getParentRoute: () => WWorkspaceCampaignsCampaignIdRoute,
  } as any)
const WWorkspaceCampaignsCampaignIdResultsRoute =
  WWorkspaceCampaignsCampaignIdResultsRouteImport.update({
    id: '/results',
    path: '/results',
    getParentRoute: () => WWorkspaceCampaignsCampaignIdRoute,
  } as any)
const WWorkspaceCampaignsCampaignIdReviewRoute =
  WWorkspaceCampaignsCampaignIdReviewRouteImport.update({
    id: '/review',
    path: '/review',
    getParentRoute: () => WWorkspaceCampaignsCampaignIdRoute,
  } as any)
const WWorkspaceCampaignsCampaignIdScheduleRoute =
  WWorkspaceCampaignsCampaignIdScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => WWorkspaceCampaignsCampaignIdRoute,
  } as any)
const WWorkspaceChannelsConnectAttemptIdRoute =
  WWorkspaceChannelsConnectAttemptIdRouteImport.update({
    id: '/channels/connect/$attemptId',
    path: '/channels/connect/$attemptId',
    getParentRoute: () => WWorkspaceRoute,
  } as any)
const WWorkspaceContactsImportIndexRoute =
  WWorkspaceContactsImportIndexRouteImport.update({
    id: '/import/',
    path: '/import/',
    getParentRoute: () => WWorkspaceContactsRoute,
  } as any)
const WWorkspaceContactsSegmentsIndexRoute =
  WWorkspaceContactsSegmentsIndexRouteImport.update({
    id: '/segments/',
    path: '/segments/',
    getParentRoute: () => WWorkspaceContactsRoute,
  } as any)
const WWorkspaceContactsSegmentsSegmentIdRoute =
  WWorkspaceContactsSegmentsSegmentIdRouteImport.update({
    id: '/segments/$segmentId',
    path: '/segments/$segmentId',
    getParentRoute: () => WWorkspaceContactsRoute,
  } as any)
const WWorkspaceContactsSegmentsNewRoute =
  WWorkspaceContactsSegmentsNewRouteImport.update({
    id: '/segments/new',
    path: '/segments/new',
    getParentRoute: () => WWorkspaceContactsRoute,
  } as any)
const WWorkspaceSettingsModerationIndexRoute =
  WWorkspaceSettingsModerationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WWorkspaceSettingsModerationRoute,
  } as any)
const WWorkspaceSettingsModerationRuleIdRoute =
  WWorkspaceSettingsModerationRuleIdRouteImport.update({
    id: '/$ruleId',
    path: '/$ruleId',
    getParentRoute: () => WWorkspaceSettingsModerationRoute,
  } as any)
const WWorkspaceContactsImportImportIdIndexRoute =
  WWorkspaceContactsImportImportIdIndexRouteImport.update({
    id: '/import/$importId/',
    path: '/import/$importId/',
    getParentRoute: () => WWorkspaceContactsRoute,
  } as any)
const WWorkspaceContactsImportImportIdReviewRoute =
  WWorkspaceContactsImportImportIdReviewRouteImport.update({
    id: '/import/$importId/review',
    path: '/import/$importId/review',
    getParentRoute: () => WWorkspaceContactsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/create-workspace': typeof CreateWorkspaceRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/terms': typeof TermsRoute
  '/invite/$token': typeof InviteTokenRoute
  '/w/$workspace': typeof WWorkspaceRouteWithChildren
  '/w/$workspace/automations': typeof WWorkspaceAutomationsRouteWithChildren
  '/w/$workspace/campaigns': typeof WWorkspaceCampaignsRouteWithChildren
  '/w/$workspace/comments': typeof WWorkspaceCommentsRoute
  '/w/$workspace/contacts': typeof WWorkspaceContactsRouteWithChildren
  '/w/$workspace/getting-started': typeof WWorkspaceGettingStartedRoute
  '/w/$workspace/handovers': typeof WWorkspaceHandoversRoute
  '/w/$workspace/inbox': typeof WWorkspaceInboxRoute
  '/w/$workspace/overview': typeof WWorkspaceOverviewRoute
  '/w/$workspace/reports': typeof WWorkspaceReportsRouteWithChildren
  '/w/$workspace/settings': typeof WWorkspaceSettingsRouteWithChildren
  '/w/$workspace/': typeof WWorkspaceIndexRoute
  '/w/$workspace/automations/$automationId': typeof WWorkspaceAutomationsAutomationIdRouteWithChildren
  '/w/$workspace/automations/moderation': typeof WWorkspaceAutomationsModerationRouteWithChildren
  '/w/$workspace/automations/new': typeof WWorkspaceAutomationsNewRoute
  '/w/$workspace/automations/runs': typeof WWorkspaceAutomationsRunsRouteWithChildren
  '/w/$workspace/automations/templates': typeof WWorkspaceAutomationsTemplatesRoute
  '/w/$workspace/campaigns/$campaignId': typeof WWorkspaceCampaignsCampaignIdRouteWithChildren
  '/w/$workspace/channels/$connectionId': typeof WWorkspaceChannelsConnectionIdRoute
  '/w/$workspace/channels/new': typeof WWorkspaceChannelsNewRoute
  '/w/$workspace/contacts/$contactId': typeof WWorkspaceContactsContactIdRoute
  '/w/$workspace/enrol/$conversationId': typeof WWorkspaceEnrolConversationIdRoute
  '/w/$workspace/release/$conversationId': typeof WWorkspaceReleaseConversationIdRoute
  '/w/$workspace/reports/automations': typeof WWorkspaceReportsAutomationsRoute
  '/w/$workspace/reports/campaigns': typeof WWorkspaceReportsCampaignsRoute
  '/w/$workspace/reports/support': typeof WWorkspaceReportsSupportRoute
  '/w/$workspace/settings/audit': typeof WWorkspaceSettingsAuditRoute
  '/w/$workspace/settings/channels': typeof WWorkspaceSettingsChannelsRoute
  '/w/$workspace/settings/consent': typeof WWorkspaceSettingsConsentRoute
  '/w/$workspace/settings/fields': typeof WWorkspaceSettingsFieldsRoute
  '/w/$workspace/settings/general': typeof WWorkspaceSettingsGeneralRoute
  '/w/$workspace/settings/moderation': typeof WWorkspaceSettingsModerationRouteWithChildren
  '/w/$workspace/settings/profile': typeof WWorkspaceSettingsProfileRoute
  '/w/$workspace/settings/roles': typeof WWorkspaceSettingsRolesRoute
  '/w/$workspace/settings/saved-replies': typeof WWorkspaceSettingsSavedRepliesRoute
  '/w/$workspace/settings/team': typeof WWorkspaceSettingsTeamRoute
  '/w/$workspace/automations/': typeof WWorkspaceAutomationsIndexRoute
  '/w/$workspace/campaigns/': typeof WWorkspaceCampaignsIndexRoute
  '/w/$workspace/contacts/': typeof WWorkspaceContactsIndexRoute
  '/w/$workspace/reports/': typeof WWorkspaceReportsIndexRoute
  '/w/$workspace/settings/': typeof WWorkspaceSettingsIndexRoute
  '/w/$workspace/automations/$automationId/publish': typeof WWorkspaceAutomationsAutomationIdPublishRoute
  '/w/$workspace/automations/$automationId/simulate': typeof WWorkspaceAutomationsAutomationIdSimulateRoute
  '/w/$workspace/automations/$automationId/validate': typeof WWorkspaceAutomationsAutomationIdValidateRoute
  '/w/$workspace/automations/moderation/$ruleId': typeof WWorkspaceAutomationsModerationRuleIdRoute
  '/w/$workspace/automations/runs/$runId': typeof WWorkspaceAutomationsRunsRunIdRoute
  '/w/$workspace/campaigns/$campaignId/audience': typeof WWorkspaceCampaignsCampaignIdAudienceRoute
  '/w/$workspace/campaigns/$campaignId/message': typeof WWorkspaceCampaignsCampaignIdMessageRoute
  '/w/$workspace/campaigns/$campaignId/recipients': typeof WWorkspaceCampaignsCampaignIdRecipientsRoute
  '/w/$workspace/campaigns/$campaignId/results': typeof WWorkspaceCampaignsCampaignIdResultsRoute
  '/w/$workspace/campaigns/$campaignId/review': typeof WWorkspaceCampaignsCampaignIdReviewRoute
  '/w/$workspace/campaigns/$campaignId/schedule': typeof WWorkspaceCampaignsCampaignIdScheduleRoute
  '/w/$workspace/channels/connect/$attemptId': typeof WWorkspaceChannelsConnectAttemptIdRoute
  '/w/$workspace/contacts/segments/$segmentId': typeof WWorkspaceContactsSegmentsSegmentIdRoute
  '/w/$workspace/contacts/segments/new': typeof WWorkspaceContactsSegmentsNewRoute
  '/w/$workspace/settings/moderation/$ruleId': typeof WWorkspaceSettingsModerationRuleIdRoute
  '/w/$workspace/automations/$automationId/': typeof WWorkspaceAutomationsAutomationIdIndexRoute
  '/w/$workspace/automations/moderation/': typeof WWorkspaceAutomationsModerationIndexRoute
  '/w/$workspace/automations/runs/': typeof WWorkspaceAutomationsRunsIndexRoute
  '/w/$workspace/campaigns/$campaignId/': typeof WWorkspaceCampaignsCampaignIdIndexRoute
  '/w/$workspace/contacts/import/': typeof WWorkspaceContactsImportIndexRoute
  '/w/$workspace/contacts/segments/': typeof WWorkspaceContactsSegmentsIndexRoute
  '/w/$workspace/settings/moderation/': typeof WWorkspaceSettingsModerationIndexRoute
  '/w/$workspace/contacts/import/$importId/review': typeof WWorkspaceContactsImportImportIdReviewRoute
  '/w/$workspace/contacts/import/$importId/': typeof WWorkspaceContactsImportImportIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/create-workspace': typeof CreateWorkspaceRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/terms': typeof TermsRoute
  '/invite/$token': typeof InviteTokenRoute
  '/w/$workspace/comments': typeof WWorkspaceCommentsRoute
  '/w/$workspace/getting-started': typeof WWorkspaceGettingStartedRoute
  '/w/$workspace/handovers': typeof WWorkspaceHandoversRoute
  '/w/$workspace/inbox': typeof WWorkspaceInboxRoute
  '/w/$workspace/overview': typeof WWorkspaceOverviewRoute
  '/w/$workspace': typeof WWorkspaceIndexRoute
  '/w/$workspace/automations/new': typeof WWorkspaceAutomationsNewRoute
  '/w/$workspace/automations/templates': typeof WWorkspaceAutomationsTemplatesRoute
  '/w/$workspace/channels/$connectionId': typeof WWorkspaceChannelsConnectionIdRoute
  '/w/$workspace/channels/new': typeof WWorkspaceChannelsNewRoute
  '/w/$workspace/contacts/$contactId': typeof WWorkspaceContactsContactIdRoute
  '/w/$workspace/enrol/$conversationId': typeof WWorkspaceEnrolConversationIdRoute
  '/w/$workspace/release/$conversationId': typeof WWorkspaceReleaseConversationIdRoute
  '/w/$workspace/reports/automations': typeof WWorkspaceReportsAutomationsRoute
  '/w/$workspace/reports/campaigns': typeof WWorkspaceReportsCampaignsRoute
  '/w/$workspace/reports/support': typeof WWorkspaceReportsSupportRoute
  '/w/$workspace/settings/audit': typeof WWorkspaceSettingsAuditRoute
  '/w/$workspace/settings/channels': typeof WWorkspaceSettingsChannelsRoute
  '/w/$workspace/settings/consent': typeof WWorkspaceSettingsConsentRoute
  '/w/$workspace/settings/fields': typeof WWorkspaceSettingsFieldsRoute
  '/w/$workspace/settings/general': typeof WWorkspaceSettingsGeneralRoute
  '/w/$workspace/settings/profile': typeof WWorkspaceSettingsProfileRoute
  '/w/$workspace/settings/roles': typeof WWorkspaceSettingsRolesRoute
  '/w/$workspace/settings/saved-replies': typeof WWorkspaceSettingsSavedRepliesRoute
  '/w/$workspace/settings/team': typeof WWorkspaceSettingsTeamRoute
  '/w/$workspace/automations': typeof WWorkspaceAutomationsIndexRoute
  '/w/$workspace/campaigns': typeof WWorkspaceCampaignsIndexRoute
  '/w/$workspace/contacts': typeof WWorkspaceContactsIndexRoute
  '/w/$workspace/reports': typeof WWorkspaceReportsIndexRoute
  '/w/$workspace/settings': typeof WWorkspaceSettingsIndexRoute
  '/w/$workspace/automations/$automationId/publish': typeof WWorkspaceAutomationsAutomationIdPublishRoute
  '/w/$workspace/automations/$automationId/simulate': typeof WWorkspaceAutomationsAutomationIdSimulateRoute
  '/w/$workspace/automations/$automationId/validate': typeof WWorkspaceAutomationsAutomationIdValidateRoute
  '/w/$workspace/automations/moderation/$ruleId': typeof WWorkspaceAutomationsModerationRuleIdRoute
  '/w/$workspace/automations/runs/$runId': typeof WWorkspaceAutomationsRunsRunIdRoute
  '/w/$workspace/campaigns/$campaignId/audience': typeof WWorkspaceCampaignsCampaignIdAudienceRoute
  '/w/$workspace/campaigns/$campaignId/message': typeof WWorkspaceCampaignsCampaignIdMessageRoute
  '/w/$workspace/campaigns/$campaignId/recipients': typeof WWorkspaceCampaignsCampaignIdRecipientsRoute
  '/w/$workspace/campaigns/$campaignId/results': typeof WWorkspaceCampaignsCampaignIdResultsRoute
  '/w/$workspace/campaigns/$campaignId/review': typeof WWorkspaceCampaignsCampaignIdReviewRoute
  '/w/$workspace/campaigns/$campaignId/schedule': typeof WWorkspaceCampaignsCampaignIdScheduleRoute
  '/w/$workspace/channels/connect/$attemptId': typeof WWorkspaceChannelsConnectAttemptIdRoute
  '/w/$workspace/contacts/segments/$segmentId': typeof WWorkspaceContactsSegmentsSegmentIdRoute
  '/w/$workspace/contacts/segments/new': typeof WWorkspaceContactsSegmentsNewRoute
  '/w/$workspace/settings/moderation/$ruleId': typeof WWorkspaceSettingsModerationRuleIdRoute
  '/w/$workspace/automations/$automationId': typeof WWorkspaceAutomationsAutomationIdIndexRoute
  '/w/$workspace/automations/moderation': typeof WWorkspaceAutomationsModerationIndexRoute
  '/w/$workspace/automations/runs': typeof WWorkspaceAutomationsRunsIndexRoute
  '/w/$workspace/campaigns/$campaignId': typeof WWorkspaceCampaignsCampaignIdIndexRoute
  '/w/$workspace/contacts/import': typeof WWorkspaceContactsImportIndexRoute
  '/w/$workspace/contacts/segments': typeof WWorkspaceContactsSegmentsIndexRoute
  '/w/$workspace/settings/moderation': typeof WWorkspaceSettingsModerationIndexRoute
  '/w/$workspace/contacts/import/$importId/review': typeof WWorkspaceContactsImportImportIdReviewRoute
  '/w/$workspace/contacts/import/$importId': typeof WWorkspaceContactsImportImportIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/create-workspace': typeof CreateWorkspaceRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/terms': typeof TermsRoute
  '/invite/$token': typeof InviteTokenRoute
  '/w/$workspace': typeof WWorkspaceRouteWithChildren
  '/w/$workspace/automations': typeof WWorkspaceAutomationsRouteWithChildren
  '/w/$workspace/campaigns': typeof WWorkspaceCampaignsRouteWithChildren
  '/w/$workspace/comments': typeof WWorkspaceCommentsRoute
  '/w/$workspace/contacts': typeof WWorkspaceContactsRouteWithChildren
  '/w/$workspace/getting-started': typeof WWorkspaceGettingStartedRoute
  '/w/$workspace/handovers': typeof WWorkspaceHandoversRoute
  '/w/$workspace/inbox': typeof WWorkspaceInboxRoute
  '/w/$workspace/overview': typeof WWorkspaceOverviewRoute
  '/w/$workspace/reports': typeof WWorkspaceReportsRouteWithChildren
  '/w/$workspace/settings': typeof WWorkspaceSettingsRouteWithChildren
  '/w/$workspace/': typeof WWorkspaceIndexRoute
  '/w/$workspace/automations/$automationId': typeof WWorkspaceAutomationsAutomationIdRouteWithChildren
  '/w/$workspace/automations/moderation': typeof WWorkspaceAutomationsModerationRouteWithChildren
  '/w/$workspace/automations/new': typeof WWorkspaceAutomationsNewRoute
  '/w/$workspace/automations/runs': typeof WWorkspaceAutomationsRunsRouteWithChildren
  '/w/$workspace/automations/templates': typeof WWorkspaceAutomationsTemplatesRoute
  '/w/$workspace/campaigns/$campaignId': typeof WWorkspaceCampaignsCampaignIdRouteWithChildren
  '/w/$workspace/channels/$connectionId': typeof WWorkspaceChannelsConnectionIdRoute
  '/w/$workspace/channels/new': typeof WWorkspaceChannelsNewRoute
  '/w/$workspace/contacts/$contactId': typeof WWorkspaceContactsContactIdRoute
  '/w/$workspace/enrol/$conversationId': typeof WWorkspaceEnrolConversationIdRoute
  '/w/$workspace/release/$conversationId': typeof WWorkspaceReleaseConversationIdRoute
  '/w/$workspace/reports/automations': typeof WWorkspaceReportsAutomationsRoute
  '/w/$workspace/reports/campaigns': typeof WWorkspaceReportsCampaignsRoute
  '/w/$workspace/reports/support': typeof WWorkspaceReportsSupportRoute
  '/w/$workspace/settings/audit': typeof WWorkspaceSettingsAuditRoute
  '/w/$workspace/settings/channels': typeof WWorkspaceSettingsChannelsRoute
  '/w/$workspace/settings/consent': typeof WWorkspaceSettingsConsentRoute
  '/w/$workspace/settings/fields': typeof WWorkspaceSettingsFieldsRoute
  '/w/$workspace/settings/general': typeof WWorkspaceSettingsGeneralRoute
  '/w/$workspace/settings/moderation': typeof WWorkspaceSettingsModerationRouteWithChildren
  '/w/$workspace/settings/profile': typeof WWorkspaceSettingsProfileRoute
  '/w/$workspace/settings/roles': typeof WWorkspaceSettingsRolesRoute
  '/w/$workspace/settings/saved-replies': typeof WWorkspaceSettingsSavedRepliesRoute
  '/w/$workspace/settings/team': typeof WWorkspaceSettingsTeamRoute
  '/w/$workspace/automations/': typeof WWorkspaceAutomationsIndexRoute
  '/w/$workspace/campaigns/': typeof WWorkspaceCampaignsIndexRoute
  '/w/$workspace/contacts/': typeof WWorkspaceContactsIndexRoute
  '/w/$workspace/reports/': typeof WWorkspaceReportsIndexRoute
  '/w/$workspace/settings/': typeof WWorkspaceSettingsIndexRoute
  '/w/$workspace/automations/$automationId/publish': typeof WWorkspaceAutomationsAutomationIdPublishRoute
  '/w/$workspace/automations/$automationId/simulate': typeof WWorkspaceAutomationsAutomationIdSimulateRoute
  '/w/$workspace/automations/$automationId/validate': typeof WWorkspaceAutomationsAutomationIdValidateRoute
  '/w/$workspace/automations/moderation/$ruleId': typeof WWorkspaceAutomationsModerationRuleIdRoute
  '/w/$workspace/automations/runs/$runId': typeof WWorkspaceAutomationsRunsRunIdRoute
  '/w/$workspace/campaigns/$campaignId/audience': typeof WWorkspaceCampaignsCampaignIdAudienceRoute
  '/w/$workspace/campaigns/$campaignId/message': typeof WWorkspaceCampaignsCampaignIdMessageRoute
  '/w/$workspace/campaigns/$campaignId/recipients': typeof WWorkspaceCampaignsCampaignIdRecipientsRoute
  '/w/$workspace/campaigns/$campaignId/results': typeof WWorkspaceCampaignsCampaignIdResultsRoute
  '/w/$workspace/campaigns/$campaignId/review': typeof WWorkspaceCampaignsCampaignIdReviewRoute
  '/w/$workspace/campaigns/$campaignId/schedule': typeof WWorkspaceCampaignsCampaignIdScheduleRoute
  '/w/$workspace/channels/connect/$attemptId': typeof WWorkspaceChannelsConnectAttemptIdRoute
  '/w/$workspace/contacts/segments/$segmentId': typeof WWorkspaceContactsSegmentsSegmentIdRoute
  '/w/$workspace/contacts/segments/new': typeof WWorkspaceContactsSegmentsNewRoute
  '/w/$workspace/settings/moderation/$ruleId': typeof WWorkspaceSettingsModerationRuleIdRoute
  '/w/$workspace/automations/$automationId/': typeof WWorkspaceAutomationsAutomationIdIndexRoute
  '/w/$workspace/automations/moderation/': typeof WWorkspaceAutomationsModerationIndexRoute
  '/w/$workspace/automations/runs/': typeof WWorkspaceAutomationsRunsIndexRoute
  '/w/$workspace/campaigns/$campaignId/': typeof WWorkspaceCampaignsCampaignIdIndexRoute
  '/w/$workspace/contacts/import/': typeof WWorkspaceContactsImportIndexRoute
  '/w/$workspace/contacts/segments/': typeof WWorkspaceContactsSegmentsIndexRoute
  '/w/$workspace/settings/moderation/': typeof WWorkspaceSettingsModerationIndexRoute
  '/w/$workspace/contacts/import/$importId/review': typeof WWorkspaceContactsImportImportIdReviewRoute
  '/w/$workspace/contacts/import/$importId/': typeof WWorkspaceContactsImportImportIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/create-workspace'
    | '/forgot-password'
    | '/privacy'
    | '/reset-password'
    | '/sign-in'
    | '/terms'
    | '/invite/$token'
    | '/w/$workspace'
    | '/w/$workspace/automations'
    | '/w/$workspace/campaigns'
    | '/w/$workspace/comments'
    | '/w/$workspace/contacts'
    | '/w/$workspace/getting-started'
    | '/w/$workspace/handovers'
    | '/w/$workspace/inbox'
    | '/w/$workspace/overview'
    | '/w/$workspace/reports'
    | '/w/$workspace/settings'
    | '/w/$workspace/'
    | '/w/$workspace/automations/$automationId'
    | '/w/$workspace/automations/moderation'
    | '/w/$workspace/automations/new'
    | '/w/$workspace/automations/runs'
    | '/w/$workspace/automations/templates'
    | '/w/$workspace/campaigns/$campaignId'
    | '/w/$workspace/channels/$connectionId'
    | '/w/$workspace/channels/new'
    | '/w/$workspace/contacts/$contactId'
    | '/w/$workspace/enrol/$conversationId'
    | '/w/$workspace/release/$conversationId'
    | '/w/$workspace/reports/automations'
    | '/w/$workspace/reports/campaigns'
    | '/w/$workspace/reports/support'
    | '/w/$workspace/settings/audit'
    | '/w/$workspace/settings/channels'
    | '/w/$workspace/settings/consent'
    | '/w/$workspace/settings/fields'
    | '/w/$workspace/settings/general'
    | '/w/$workspace/settings/moderation'
    | '/w/$workspace/settings/profile'
    | '/w/$workspace/settings/roles'
    | '/w/$workspace/settings/saved-replies'
    | '/w/$workspace/settings/team'
    | '/w/$workspace/automations/'
    | '/w/$workspace/campaigns/'
    | '/w/$workspace/contacts/'
    | '/w/$workspace/reports/'
    | '/w/$workspace/settings/'
    | '/w/$workspace/automations/$automationId/publish'
    | '/w/$workspace/automations/$automationId/simulate'
    | '/w/$workspace/automations/$automationId/validate'
    | '/w/$workspace/automations/moderation/$ruleId'
    | '/w/$workspace/automations/runs/$runId'
    | '/w/$workspace/campaigns/$campaignId/audience'
    | '/w/$workspace/campaigns/$campaignId/message'
    | '/w/$workspace/campaigns/$campaignId/recipients'
    | '/w/$workspace/campaigns/$campaignId/results'
    | '/w/$workspace/campaigns/$campaignId/review'
    | '/w/$workspace/campaigns/$campaignId/schedule'
    | '/w/$workspace/channels/connect/$attemptId'
    | '/w/$workspace/contacts/segments/$segmentId'
    | '/w/$workspace/contacts/segments/new'
    | '/w/$workspace/settings/moderation/$ruleId'
    | '/w/$workspace/automations/$automationId/'
    | '/w/$workspace/automations/moderation/'
    | '/w/$workspace/automations/runs/'
    | '/w/$workspace/campaigns/$campaignId/'
    | '/w/$workspace/contacts/import/'
    | '/w/$workspace/contacts/segments/'
    | '/w/$workspace/settings/moderation/'
    | '/w/$workspace/contacts/import/$importId/review'
    | '/w/$workspace/contacts/import/$importId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/create-workspace'
    | '/forgot-password'
    | '/privacy'
    | '/reset-password'
    | '/sign-in'
    | '/terms'
    | '/invite/$token'
    | '/w/$workspace/comments'
    | '/w/$workspace/getting-started'
    | '/w/$workspace/handovers'
    | '/w/$workspace/inbox'
    | '/w/$workspace/overview'
    | '/w/$workspace'
    | '/w/$workspace/automations/new'
    | '/w/$workspace/automations/templates'
    | '/w/$workspace/channels/$connectionId'
    | '/w/$workspace/channels/new'
    | '/w/$workspace/contacts/$contactId'
    | '/w/$workspace/enrol/$conversationId'
    | '/w/$workspace/release/$conversationId'
    | '/w/$workspace/reports/automations'
    | '/w/$workspace/reports/campaigns'
    | '/w/$workspace/reports/support'
    | '/w/$workspace/settings/audit'
    | '/w/$workspace/settings/channels'
    | '/w/$workspace/settings/consent'
    | '/w/$workspace/settings/fields'
    | '/w/$workspace/settings/general'
    | '/w/$workspace/settings/profile'
    | '/w/$workspace/settings/roles'
    | '/w/$workspace/settings/saved-replies'
    | '/w/$workspace/settings/team'
    | '/w/$workspace/automations'
    | '/w/$workspace/campaigns'
    | '/w/$workspace/contacts'
    | '/w/$workspace/reports'
    | '/w/$workspace/settings'
    | '/w/$workspace/automations/$automationId/publish'
    | '/w/$workspace/automations/$automationId/simulate'
    | '/w/$workspace/automations/$automationId/validate'
    | '/w/$workspace/automations/moderation/$ruleId'
    | '/w/$workspace/automations/runs/$runId'
    | '/w/$workspace/campaigns/$campaignId/audience'
    | '/w/$workspace/campaigns/$campaignId/message'
    | '/w/$workspace/campaigns/$campaignId/recipients'
    | '/w/$workspace/campaigns/$campaignId/results'
    | '/w/$workspace/campaigns/$campaignId/review'
    | '/w/$workspace/campaigns/$campaignId/schedule'
    | '/w/$workspace/channels/connect/$attemptId'
    | '/w/$workspace/contacts/segments/$segmentId'
    | '/w/$workspace/contacts/segments/new'
    | '/w/$workspace/settings/moderation/$ruleId'
    | '/w/$workspace/automations/$automationId'
    | '/w/$workspace/automations/moderation'
    | '/w/$workspace/automations/runs'
    | '/w/$workspace/campaigns/$campaignId'
    | '/w/$workspace/contacts/import'
    | '/w/$workspace/contacts/segments'
    | '/w/$workspace/settings/moderation'
    | '/w/$workspace/contacts/import/$importId/review'
    | '/w/$workspace/contacts/import/$importId'
  id:
    | '__root__'
    | '/'
    | '/create-workspace'
    | '/forgot-password'
    | '/privacy'
    | '/reset-password'
    | '/sign-in'
    | '/terms'
    | '/invite/$token'
    | '/w/$workspace'
    | '/w/$workspace/automations'
    | '/w/$workspace/campaigns'
    | '/w/$workspace/comments'
    | '/w/$workspace/contacts'
    | '/w/$workspace/getting-started'
    | '/w/$workspace/handovers'
    | '/w/$workspace/inbox'
    | '/w/$workspace/overview'
    | '/w/$workspace/reports'
    | '/w/$workspace/settings'
    | '/w/$workspace/'
    | '/w/$workspace/automations/$automationId'
    | '/w/$workspace/automations/moderation'
    | '/w/$workspace/automations/new'
    | '/w/$workspace/automations/runs'
    | '/w/$workspace/automations/templates'
    | '/w/$workspace/campaigns/$campaignId'
    | '/w/$workspace/channels/$connectionId'
    | '/w/$workspace/channels/new'
    | '/w/$workspace/contacts/$contactId'
    | '/w/$workspace/enrol/$conversationId'
    | '/w/$workspace/release/$conversationId'
    | '/w/$workspace/reports/automations'
    | '/w/$workspace/reports/campaigns'
    | '/w/$workspace/reports/support'
    | '/w/$workspace/settings/audit'
    | '/w/$workspace/settings/channels'
    | '/w/$workspace/settings/consent'
    | '/w/$workspace/settings/fields'
    | '/w/$workspace/settings/general'
    | '/w/$workspace/settings/moderation'
    | '/w/$workspace/settings/profile'
    | '/w/$workspace/settings/roles'
    | '/w/$workspace/settings/saved-replies'
    | '/w/$workspace/settings/team'
    | '/w/$workspace/automations/'
    | '/w/$workspace/campaigns/'
    | '/w/$workspace/contacts/'
    | '/w/$workspace/reports/'
    | '/w/$workspace/settings/'
    | '/w/$workspace/automations/$automationId/publish'
    | '/w/$workspace/automations/$automationId/simulate'
    | '/w/$workspace/automations/$automationId/validate'
    | '/w/$workspace/automations/moderation/$ruleId'
    | '/w/$workspace/automations/runs/$runId'
    | '/w/$workspace/campaigns/$campaignId/audience'
    | '/w/$workspace/campaigns/$campaignId/message'
    | '/w/$workspace/campaigns/$campaignId/recipients'
    | '/w/$workspace/campaigns/$campaignId/results'
    | '/w/$workspace/campaigns/$campaignId/review'
    | '/w/$workspace/campaigns/$campaignId/schedule'
    | '/w/$workspace/channels/connect/$attemptId'
    | '/w/$workspace/contacts/segments/$segmentId'
    | '/w/$workspace/contacts/segments/new'
    | '/w/$workspace/settings/moderation/$ruleId'
    | '/w/$workspace/automations/$automationId/'
    | '/w/$workspace/automations/moderation/'
    | '/w/$workspace/automations/runs/'
    | '/w/$workspace/campaigns/$campaignId/'
    | '/w/$workspace/contacts/import/'
    | '/w/$workspace/contacts/segments/'
    | '/w/$workspace/settings/moderation/'
    | '/w/$workspace/contacts/import/$importId/review'
    | '/w/$workspace/contacts/import/$importId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CreateWorkspaceRoute: typeof CreateWorkspaceRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  PrivacyRoute: typeof PrivacyRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignInRoute: typeof SignInRoute
  TermsRoute: typeof TermsRoute
  InviteTokenRoute: typeof InviteTokenRoute
  WWorkspaceRoute: typeof WWorkspaceRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create-workspace': {
      id: '/create-workspace'
      path: '/create-workspace'
      fullPath: '/create-workspace'
      preLoaderRoute: typeof CreateWorkspaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspace': {
      id: '/w/$workspace'
      path: '/w/$workspace'
      fullPath: '/w/$workspace'
      preLoaderRoute: typeof WWorkspaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspace/': {
      id: '/w/$workspace/'
      path: '/'
      fullPath: '/w/$workspace/'
      preLoaderRoute: typeof WWorkspaceIndexRouteImport
      parentRoute: typeof WWorkspaceRoute
    }
    '/w/$workspace/automations': {
      id: '/w/$workspace/automations'
      path: '/automations'
      fullPath: '/w/$workspace/automations'
      preLoaderRoute: typeof WWorkspaceAutomationsRouteImport
      parentRoute: typeof WWorkspaceRoute
    }
    '/w/$workspace/campaigns': {
      id: '/w/$workspace/campaigns'
      path: '/campaigns'
      fullPath: '/w/$workspace/campaigns'
      preLoaderRoute: typeof WWorkspaceCampaignsRouteImport
      parentRoute: typeof WWorkspaceRoute
    }
    '/w/$workspace/comments': {
      id: '/w/$workspace/comments'
      path: '/comments'
      fullPath: '/w/$workspace/comments'
      preLoaderRoute: typeof WWorkspaceCommentsRouteImport
      parentRoute: typeof WWorkspaceRoute
    }
    '/w/$workspace/contacts': {
      id: '/w/$workspace/contacts'
      path: '/contacts'
      fullPath: '/w/$workspace/contacts'
      preLoaderRoute: typeof WWorkspaceContactsRouteImport
      parentRoute: typeof WWorkspaceRoute
    }
    '/w/$workspace/getting-started': {
      id: '/w/$workspace/getting-started'
      path: '/getting-started'
      fullPath: '/w/$workspace/getting-started'
      preLoaderRoute: typeof WWorkspaceGettingStartedRouteImport
      parentRoute: typeof WWorkspaceRoute
    }
    '/w/$workspace/handovers': {
      id: '/w/$workspace/handovers'
      path: '/handovers'
      fullPath: '/w/$workspace/handovers'
      preLoaderRoute: typeof WWorkspaceHandoversRouteImport
      parentRoute: typeof WWorkspaceRoute
    }
    '/w/$workspace/inbox': {
      id: '/w/$workspace/inbox'
      path: '/inbox'
      fullPath: '/w/$workspace/inbox'
      preLoaderRoute: typeof WWorkspaceInboxRouteImport
      parentRoute: typeof WWorkspaceRoute
    }
    '/w/$workspace/overview': {
      id: '/w/$workspace/overview'
      path: '/overview'
      fullPath: '/w/$workspace/overview'
      preLoaderRoute: typeof WWorkspaceOverviewRouteImport
      parentRoute: typeof WWorkspaceRoute
    }
    '/w/$workspace/reports': {
      id: '/w/$workspace/reports'
      path: '/reports'
      fullPath: '/w/$workspace/reports'
      preLoaderRoute: typeof WWorkspaceReportsRouteImport
      parentRoute: typeof WWorkspaceRoute
    }
    '/w/$workspace/settings': {
      id: '/w/$workspace/settings'
      path: '/settings'
      fullPath: '/w/$workspace/settings'
      preLoaderRoute: typeof WWorkspaceSettingsRouteImport
      parentRoute: typeof WWorkspaceRoute
    }
    '/w/$workspace/automations/': {
      id: '/w/$workspace/automations/'
      path: '/'
      fullPath: '/w/$workspace/automations/'
      preLoaderRoute: typeof WWorkspaceAutomationsIndexRouteImport
      parentRoute: typeof WWorkspaceAutomationsRoute
    }
    '/w/$workspace/automations/$automationId': {
      id: '/w/$workspace/automations/$automationId'
      path: '/$automationId'
      fullPath: '/w/$workspace/automations/$automationId'
      preLoaderRoute: typeof WWorkspaceAutomationsAutomationIdRouteImport
      parentRoute: typeof WWorkspaceAutomationsRoute
    }
    '/w/$workspace/automations/moderation': {
      id: '/w/$workspace/automations/moderation'
      path: '/moderation'
      fullPath: '/w/$workspace/automations/moderation'
      preLoaderRoute: typeof WWorkspaceAutomationsModerationRouteImport
      parentRoute: typeof WWorkspaceAutomationsRoute
    }
    '/w/$workspace/automations/new': {
      id: '/w/$workspace/automations/new'
      path: '/new'
      fullPath: '/w/$workspace/automations/new'
      preLoaderRoute: typeof WWorkspaceAutomationsNewRouteImport
      parentRoute: typeof WWorkspaceAutomationsRoute
    }
    '/w/$workspace/automations/runs': {
      id: '/w/$workspace/automations/runs'
      path: '/runs'
      fullPath: '/w/$workspace/automations/runs'
      preLoaderRoute: typeof WWorkspaceAutomationsRunsRouteImport
      parentRoute: typeof WWorkspaceAutomationsRoute
    }
    '/w/$workspace/automations/templates': {
      id: '/w/$workspace/automations/templates'
      path: '/templates'
      fullPath: '/w/$workspace/automations/templates'
      preLoaderRoute: typeof WWorkspaceAutomationsTemplatesRouteImport
      parentRoute: typeof WWorkspaceAutomationsRoute
    }
    '/w/$workspace/campaigns/': {
      id: '/w/$workspace/campaigns/'
      path: '/'
      fullPath: '/w/$workspace/campaigns/'
      preLoaderRoute: typeof WWorkspaceCampaignsIndexRouteImport
      parentRoute: typeof WWorkspaceCampaignsRoute
    }
    '/w/$workspace/campaigns/$campaignId': {
      id: '/w/$workspace/campaigns/$campaignId'
      path: '/$campaignId'
      fullPath: '/w/$workspace/campaigns/$campaignId'
      preLoaderRoute: typeof WWorkspaceCampaignsCampaignIdRouteImport
      parentRoute: typeof WWorkspaceCampaignsRoute
    }
    '/w/$workspace/channels/$connectionId': {
      id: '/w/$workspace/channels/$connectionId'
      path: '/channels/$connectionId'
      fullPath: '/w/$workspace/channels/$connectionId'
      preLoaderRoute: typeof WWorkspaceChannelsConnectionIdRouteImport
      parentRoute: typeof WWorkspaceRoute
    }
    '/w/$workspace/channels/new': {
      id: '/w/$workspace/channels/new'
      path: '/channels/new'
      fullPath: '/w/$workspace/channels/new'
      preLoaderRoute: typeof WWorkspaceChannelsNewRouteImport
      parentRoute: typeof WWorkspaceRoute
    }
    '/w/$workspace/contacts/': {
      id: '/w/$workspace/contacts/'
      path: '/'
      fullPath: '/w/$workspace/contacts/'
      preLoaderRoute: typeof WWorkspaceContactsIndexRouteImport
      parentRoute: typeof WWorkspaceContactsRoute
    }
    '/w/$workspace/contacts/$contactId': {
      id: '/w/$workspace/contacts/$contactId'
      path: '/$contactId'
      fullPath: '/w/$workspace/contacts/$contactId'
      preLoaderRoute: typeof WWorkspaceContactsContactIdRouteImport
      parentRoute: typeof WWorkspaceContactsRoute
    }
    '/w/$workspace/enrol/$conversationId': {
      id: '/w/$workspace/enrol/$conversationId'
      path: '/enrol/$conversationId'
      fullPath: '/w/$workspace/enrol/$conversationId'
      preLoaderRoute: typeof WWorkspaceEnrolConversationIdRouteImport
      parentRoute: typeof WWorkspaceRoute
    }
    '/w/$workspace/release/$conversationId': {
      id: '/w/$workspace/release/$conversationId'
      path: '/release/$conversationId'
      fullPath: '/w/$workspace/release/$conversationId'
      preLoaderRoute: typeof WWorkspaceReleaseConversationIdRouteImport
      parentRoute: typeof WWorkspaceRoute
    }
    '/w/$workspace/reports/': {
      id: '/w/$workspace/reports/'
      path: '/'
      fullPath: '/w/$workspace/reports/'
      preLoaderRoute: typeof WWorkspaceReportsIndexRouteImport
      parentRoute: typeof WWorkspaceReportsRoute
    }
    '/w/$workspace/reports/automations': {
      id: '/w/$workspace/reports/automations'
      path: '/automations'
      fullPath: '/w/$workspace/reports/automations'
      preLoaderRoute: typeof WWorkspaceReportsAutomationsRouteImport
      parentRoute: typeof WWorkspaceReportsRoute
    }
    '/w/$workspace/reports/campaigns': {
      id: '/w/$workspace/reports/campaigns'
      path: '/campaigns'
      fullPath: '/w/$workspace/reports/campaigns'
      preLoaderRoute: typeof WWorkspaceReportsCampaignsRouteImport
      parentRoute: typeof WWorkspaceReportsRoute
    }
    '/w/$workspace/reports/support': {
      id: '/w/$workspace/reports/support'
      path: '/support'
      fullPath: '/w/$workspace/reports/support'
      preLoaderRoute: typeof WWorkspaceReportsSupportRouteImport
      parentRoute: typeof WWorkspaceReportsRoute
    }
    '/w/$workspace/settings/': {
      id: '/w/$workspace/settings/'
      path: '/'
      fullPath: '/w/$workspace/settings/'
      preLoaderRoute: typeof WWorkspaceSettingsIndexRouteImport
      parentRoute: typeof WWorkspaceSettingsRoute
    }
    '/w/$workspace/settings/audit': {
      id: '/w/$workspace/settings/audit'
      path: '/audit'
      fullPath: '/w/$workspace/settings/audit'
      preLoaderRoute: typeof WWorkspaceSettingsAuditRouteImport
      parentRoute: typeof WWorkspaceSettingsRoute
    }
    '/w/$workspace/settings/channels': {
      id: '/w/$workspace/settings/channels'
      path: '/channels'
      fullPath: '/w/$workspace/settings/channels'
      preLoaderRoute: typeof WWorkspaceSettingsChannelsRouteImport
      parentRoute: typeof WWorkspaceSettingsRoute
    }
    '/w/$workspace/settings/consent': {
      id: '/w/$workspace/settings/consent'
      path: '/consent'
      fullPath: '/w/$workspace/settings/consent'
      preLoaderRoute: typeof WWorkspaceSettingsConsentRouteImport
      parentRoute: typeof WWorkspaceSettingsRoute
    }
    '/w/$workspace/settings/fields': {
      id: '/w/$workspace/settings/fields'
      path: '/fields'
      fullPath: '/w/$workspace/settings/fields'
      preLoaderRoute: typeof WWorkspaceSettingsFieldsRouteImport
      parentRoute: typeof WWorkspaceSettingsRoute
    }
    '/w/$workspace/settings/general': {
      id: '/w/$workspace/settings/general'
      path: '/general'
      fullPath: '/w/$workspace/settings/general'
      preLoaderRoute: typeof WWorkspaceSettingsGeneralRouteImport
      parentRoute: typeof WWorkspaceSettingsRoute
    }
    '/w/$workspace/settings/moderation': {
      id: '/w/$workspace/settings/moderation'
      path: '/moderation'
      fullPath: '/w/$workspace/settings/moderation'
      preLoaderRoute: typeof WWorkspaceSettingsModerationRouteImport
      parentRoute: typeof WWorkspaceSettingsRoute
    }
    '/w/$workspace/settings/profile': {
      id: '/w/$workspace/settings/profile'
      path: '/profile'
      fullPath: '/w/$workspace/settings/profile'
      preLoaderRoute: typeof WWorkspaceSettingsProfileRouteImport
      parentRoute: typeof WWorkspaceSettingsRoute
    }
    '/w/$workspace/settings/roles': {
      id: '/w/$workspace/settings/roles'
      path: '/roles'
      fullPath: '/w/$workspace/settings/roles'
      preLoaderRoute: typeof WWorkspaceSettingsRolesRouteImport
      parentRoute: typeof WWorkspaceSettingsRoute
    }
    '/w/$workspace/settings/saved-replies': {
      id: '/w/$workspace/settings/saved-replies'
      path: '/saved-replies'
      fullPath: '/w/$workspace/settings/saved-replies'
      preLoaderRoute: typeof WWorkspaceSettingsSavedRepliesRouteImport
      parentRoute: typeof WWorkspaceSettingsRoute
    }
    '/w/$workspace/settings/team': {
      id: '/w/$workspace/settings/team'
      path: '/team'
      fullPath: '/w/$workspace/settings/team'
      preLoaderRoute: typeof WWorkspaceSettingsTeamRouteImport
      parentRoute: typeof WWorkspaceSettingsRoute
    }
    '/w/$workspace/automations/$automationId/': {
      id: '/w/$workspace/automations/$automationId/'
      path: '/'
      fullPath: '/w/$workspace/automations/$automationId/'
      preLoaderRoute: typeof WWorkspaceAutomationsAutomationIdIndexRouteImport
      parentRoute: typeof WWorkspaceAutomationsAutomationIdRoute
    }
    '/w/$workspace/automations/$automationId/publish': {
      id: '/w/$workspace/automations/$automationId/publish'
      path: '/publish'
      fullPath: '/w/$workspace/automations/$automationId/publish'
      preLoaderRoute: typeof WWorkspaceAutomationsAutomationIdPublishRouteImport
      parentRoute: typeof WWorkspaceAutomationsAutomationIdRoute
    }
    '/w/$workspace/automations/$automationId/simulate': {
      id: '/w/$workspace/automations/$automationId/simulate'
      path: '/simulate'
      fullPath: '/w/$workspace/automations/$automationId/simulate'
      preLoaderRoute: typeof WWorkspaceAutomationsAutomationIdSimulateRouteImport
      parentRoute: typeof WWorkspaceAutomationsAutomationIdRoute
    }
    '/w/$workspace/automations/$automationId/validate': {
      id: '/w/$workspace/automations/$automationId/validate'
      path: '/validate'
      fullPath: '/w/$workspace/automations/$automationId/validate'
      preLoaderRoute: typeof WWorkspaceAutomationsAutomationIdValidateRouteImport
      parentRoute: typeof WWorkspaceAutomationsAutomationIdRoute
    }
    '/w/$workspace/automations/moderation/': {
      id: '/w/$workspace/automations/moderation/'
      path: '/'
      fullPath: '/w/$workspace/automations/moderation/'
      preLoaderRoute: typeof WWorkspaceAutomationsModerationIndexRouteImport
      parentRoute: typeof WWorkspaceAutomationsModerationRoute
    }
    '/w/$workspace/automations/moderation/$ruleId': {
      id: '/w/$workspace/automations/moderation/$ruleId'
      path: '/$ruleId'
      fullPath: '/w/$workspace/automations/moderation/$ruleId'
      preLoaderRoute: typeof WWorkspaceAutomationsModerationRuleIdRouteImport
      parentRoute: typeof WWorkspaceAutomationsModerationRoute
    }
    '/w/$workspace/automations/runs/': {
      id: '/w/$workspace/automations/runs/'
      path: '/'
      fullPath: '/w/$workspace/automations/runs/'
      preLoaderRoute: typeof WWorkspaceAutomationsRunsIndexRouteImport
      parentRoute: typeof WWorkspaceAutomationsRunsRoute
    }
    '/w/$workspace/automations/runs/$runId': {
      id: '/w/$workspace/automations/runs/$runId'
      path: '/$runId'
      fullPath: '/w/$workspace/automations/runs/$runId'
      preLoaderRoute: typeof WWorkspaceAutomationsRunsRunIdRouteImport
      parentRoute: typeof WWorkspaceAutomationsRunsRoute
    }
    '/w/$workspace/campaigns/$campaignId/': {
      id: '/w/$workspace/campaigns/$campaignId/'
      path: '/'
      fullPath: '/w/$workspace/campaigns/$campaignId/'
      preLoaderRoute: typeof WWorkspaceCampaignsCampaignIdIndexRouteImport
      parentRoute: typeof WWorkspaceCampaignsCampaignIdRoute
    }
    '/w/$workspace/campaigns/$campaignId/audience': {
      id: '/w/$workspace/campaigns/$campaignId/audience'
      path: '/audience'
      fullPath: '/w/$workspace/campaigns/$campaignId/audience'
      preLoaderRoute: typeof WWorkspaceCampaignsCampaignIdAudienceRouteImport
      parentRoute: typeof WWorkspaceCampaignsCampaignIdRoute
    }
    '/w/$workspace/campaigns/$campaignId/message': {
      id: '/w/$workspace/campaigns/$campaignId/message'
      path: '/message'
      fullPath: '/w/$workspace/campaigns/$campaignId/message'
      preLoaderRoute: typeof WWorkspaceCampaignsCampaignIdMessageRouteImport
      parentRoute: typeof WWorkspaceCampaignsCampaignIdRoute
    }
    '/w/$workspace/campaigns/$campaignId/recipients': {
      id: '/w/$workspace/campaigns/$campaignId/recipients'
      path: '/recipients'
      fullPath: '/w/$workspace/campaigns/$campaignId/recipients'
      preLoaderRoute: typeof WWorkspaceCampaignsCampaignIdRecipientsRouteImport
      parentRoute: typeof WWorkspaceCampaignsCampaignIdRoute
    }
    '/w/$workspace/campaigns/$campaignId/results': {
      id: '/w/$workspace/campaigns/$campaignId/results'
      path: '/results'
      fullPath: '/w/$workspace/campaigns/$campaignId/results'
      preLoaderRoute: typeof WWorkspaceCampaignsCampaignIdResultsRouteImport
      parentRoute: typeof WWorkspaceCampaignsCampaignIdRoute
    }
    '/w/$workspace/campaigns/$campaignId/review': {
      id: '/w/$workspace/campaigns/$campaignId/review'
      path: '/review'
      fullPath: '/w/$workspace/campaigns/$campaignId/review'
      preLoaderRoute: typeof WWorkspaceCampaignsCampaignIdReviewRouteImport
      parentRoute: typeof WWorkspaceCampaignsCampaignIdRoute
    }
    '/w/$workspace/campaigns/$campaignId/schedule': {
      id: '/w/$workspace/campaigns/$campaignId/schedule'
      path: '/schedule'
      fullPath: '/w/$workspace/campaigns/$campaignId/schedule'
      preLoaderRoute: typeof WWorkspaceCampaignsCampaignIdScheduleRouteImport
      parentRoute: typeof WWorkspaceCampaignsCampaignIdRoute
    }
    '/w/$workspace/channels/connect/$attemptId': {
      id: '/w/$workspace/channels/connect/$attemptId'
      path: '/channels/connect/$attemptId'
      fullPath: '/w/$workspace/channels/connect/$attemptId'
      preLoaderRoute: typeof WWorkspaceChannelsConnectAttemptIdRouteImport
      parentRoute: typeof WWorkspaceRoute
    }
    '/w/$workspace/contacts/import/': {
      id: '/w/$workspace/contacts/import/'
      path: '/import'
      fullPath: '/w/$workspace/contacts/import/'
      preLoaderRoute: typeof WWorkspaceContactsImportIndexRouteImport
      parentRoute: typeof WWorkspaceContactsRoute
    }
    '/w/$workspace/contacts/segments/': {
      id: '/w/$workspace/contacts/segments/'
      path: '/segments'
      fullPath: '/w/$workspace/contacts/segments/'
      preLoaderRoute: typeof WWorkspaceContactsSegmentsIndexRouteImport
      parentRoute: typeof WWorkspaceContactsRoute
    }
    '/w/$workspace/contacts/segments/$segmentId': {
      id: '/w/$workspace/contacts/segments/$segmentId'
      path: '/segments/$segmentId'
      fullPath: '/w/$workspace/contacts/segments/$segmentId'
      preLoaderRoute: typeof WWorkspaceContactsSegmentsSegmentIdRouteImport
      parentRoute: typeof WWorkspaceContactsRoute
    }
    '/w/$workspace/contacts/segments/new': {
      id: '/w/$workspace/contacts/segments/new'
      path: '/segments/new'
      fullPath: '/w/$workspace/contacts/segments/new'
      preLoaderRoute: typeof WWorkspaceContactsSegmentsNewRouteImport
      parentRoute: typeof WWorkspaceContactsRoute
    }
    '/w/$workspace/settings/moderation/': {
      id: '/w/$workspace/settings/moderation/'
      path: '/'
      fullPath: '/w/$workspace/settings/moderation/'
      preLoaderRoute: typeof WWorkspaceSettingsModerationIndexRouteImport
      parentRoute: typeof WWorkspaceSettingsModerationRoute
    }
    '/w/$workspace/settings/moderation/$ruleId': {
      id: '/w/$workspace/settings/moderation/$ruleId'
      path: '/$ruleId'
      fullPath: '/w/$workspace/settings/moderation/$ruleId'
      preLoaderRoute: typeof WWorkspaceSettingsModerationRuleIdRouteImport
      parentRoute: typeof WWorkspaceSettingsModerationRoute
    }
    '/w/$workspace/contacts/import/$importId/': {
      id: '/w/$workspace/contacts/import/$importId/'
      path: '/import/$importId'
      fullPath: '/w/$workspace/contacts/import/$importId/'
      preLoaderRoute: typeof WWorkspaceContactsImportImportIdIndexRouteImport
      parentRoute: typeof WWorkspaceContactsRoute
    }
    '/w/$workspace/contacts/import/$importId/review': {
      id: '/w/$workspace/contacts/import/$importId/review'
      path: '/import/$importId/review'
      fullPath: '/w/$workspace/contacts/import/$importId/review'
      preLoaderRoute: typeof WWorkspaceContactsImportImportIdReviewRouteImport
      parentRoute: typeof WWorkspaceContactsRoute
    }
  }
}

interface WWorkspaceAutomationsAutomationIdRouteChildren {
  WWorkspaceAutomationsAutomationIdPublishRoute: typeof WWorkspaceAutomationsAutomationIdPublishRoute
  WWorkspaceAutomationsAutomationIdSimulateRoute: typeof WWorkspaceAutomationsAutomationIdSimulateRoute
  WWorkspaceAutomationsAutomationIdValidateRoute: typeof WWorkspaceAutomationsAutomationIdValidateRoute
  WWorkspaceAutomationsAutomationIdIndexRoute: typeof WWorkspaceAutomationsAutomationIdIndexRoute
}

const WWorkspaceAutomationsAutomationIdRouteChildren: WWorkspaceAutomationsAutomationIdRouteChildren =
  {
    WWorkspaceAutomationsAutomationIdPublishRoute:
      WWorkspaceAutomationsAutomationIdPublishRoute,
    WWorkspaceAutomationsAutomationIdSimulateRoute:
      WWorkspaceAutomationsAutomationIdSimulateRoute,
    WWorkspaceAutomationsAutomationIdValidateRoute:
      WWorkspaceAutomationsAutomationIdValidateRoute,
    WWorkspaceAutomationsAutomationIdIndexRoute:
      WWorkspaceAutomationsAutomationIdIndexRoute,
  }

const WWorkspaceAutomationsAutomationIdRouteWithChildren =
  WWorkspaceAutomationsAutomationIdRoute._addFileChildren(
    WWorkspaceAutomationsAutomationIdRouteChildren,
  )

interface WWorkspaceAutomationsModerationRouteChildren {
  WWorkspaceAutomationsModerationRuleIdRoute: typeof WWorkspaceAutomationsModerationRuleIdRoute
  WWorkspaceAutomationsModerationIndexRoute: typeof WWorkspaceAutomationsModerationIndexRoute
}

const WWorkspaceAutomationsModerationRouteChildren: WWorkspaceAutomationsModerationRouteChildren =
  {
    WWorkspaceAutomationsModerationRuleIdRoute:
      WWorkspaceAutomationsModerationRuleIdRoute,
    WWorkspaceAutomationsModerationIndexRoute:
      WWorkspaceAutomationsModerationIndexRoute,
  }

const WWorkspaceAutomationsModerationRouteWithChildren =
  WWorkspaceAutomationsModerationRoute._addFileChildren(
    WWorkspaceAutomationsModerationRouteChildren,
  )

interface WWorkspaceAutomationsRunsRouteChildren {
  WWorkspaceAutomationsRunsRunIdRoute: typeof WWorkspaceAutomationsRunsRunIdRoute
  WWorkspaceAutomationsRunsIndexRoute: typeof WWorkspaceAutomationsRunsIndexRoute
}

const WWorkspaceAutomationsRunsRouteChildren: WWorkspaceAutomationsRunsRouteChildren =
  {
    WWorkspaceAutomationsRunsRunIdRoute: WWorkspaceAutomationsRunsRunIdRoute,
    WWorkspaceAutomationsRunsIndexRoute: WWorkspaceAutomationsRunsIndexRoute,
  }

const WWorkspaceAutomationsRunsRouteWithChildren =
  WWorkspaceAutomationsRunsRoute._addFileChildren(
    WWorkspaceAutomationsRunsRouteChildren,
  )

interface WWorkspaceAutomationsRouteChildren {
  WWorkspaceAutomationsAutomationIdRoute: typeof WWorkspaceAutomationsAutomationIdRouteWithChildren
  WWorkspaceAutomationsModerationRoute: typeof WWorkspaceAutomationsModerationRouteWithChildren
  WWorkspaceAutomationsNewRoute: typeof WWorkspaceAutomationsNewRoute
  WWorkspaceAutomationsRunsRoute: typeof WWorkspaceAutomationsRunsRouteWithChildren
  WWorkspaceAutomationsTemplatesRoute: typeof WWorkspaceAutomationsTemplatesRoute
  WWorkspaceAutomationsIndexRoute: typeof WWorkspaceAutomationsIndexRoute
}

const WWorkspaceAutomationsRouteChildren: WWorkspaceAutomationsRouteChildren = {
  WWorkspaceAutomationsAutomationIdRoute:
    WWorkspaceAutomationsAutomationIdRouteWithChildren,
  WWorkspaceAutomationsModerationRoute:
    WWorkspaceAutomationsModerationRouteWithChildren,
  WWorkspaceAutomationsNewRoute: WWorkspaceAutomationsNewRoute,
  WWorkspaceAutomationsRunsRoute: WWorkspaceAutomationsRunsRouteWithChildren,
  WWorkspaceAutomationsTemplatesRoute: WWorkspaceAutomationsTemplatesRoute,
  WWorkspaceAutomationsIndexRoute: WWorkspaceAutomationsIndexRoute,
}

const WWorkspaceAutomationsRouteWithChildren =
  WWorkspaceAutomationsRoute._addFileChildren(
    WWorkspaceAutomationsRouteChildren,
  )

interface WWorkspaceCampaignsCampaignIdRouteChildren {
  WWorkspaceCampaignsCampaignIdAudienceRoute: typeof WWorkspaceCampaignsCampaignIdAudienceRoute
  WWorkspaceCampaignsCampaignIdMessageRoute: typeof WWorkspaceCampaignsCampaignIdMessageRoute
  WWorkspaceCampaignsCampaignIdRecipientsRoute: typeof WWorkspaceCampaignsCampaignIdRecipientsRoute
  WWorkspaceCampaignsCampaignIdResultsRoute: typeof WWorkspaceCampaignsCampaignIdResultsRoute
  WWorkspaceCampaignsCampaignIdReviewRoute: typeof WWorkspaceCampaignsCampaignIdReviewRoute
  WWorkspaceCampaignsCampaignIdScheduleRoute: typeof WWorkspaceCampaignsCampaignIdScheduleRoute
  WWorkspaceCampaignsCampaignIdIndexRoute: typeof WWorkspaceCampaignsCampaignIdIndexRoute
}

const WWorkspaceCampaignsCampaignIdRouteChildren: WWorkspaceCampaignsCampaignIdRouteChildren =
  {
    WWorkspaceCampaignsCampaignIdAudienceRoute:
      WWorkspaceCampaignsCampaignIdAudienceRoute,
    WWorkspaceCampaignsCampaignIdMessageRoute:
      WWorkspaceCampaignsCampaignIdMessageRoute,
    WWorkspaceCampaignsCampaignIdRecipientsRoute:
      WWorkspaceCampaignsCampaignIdRecipientsRoute,
    WWorkspaceCampaignsCampaignIdResultsRoute:
      WWorkspaceCampaignsCampaignIdResultsRoute,
    WWorkspaceCampaignsCampaignIdReviewRoute:
      WWorkspaceCampaignsCampaignIdReviewRoute,
    WWorkspaceCampaignsCampaignIdScheduleRoute:
      WWorkspaceCampaignsCampaignIdScheduleRoute,
    WWorkspaceCampaignsCampaignIdIndexRoute:
      WWorkspaceCampaignsCampaignIdIndexRoute,
  }

const WWorkspaceCampaignsCampaignIdRouteWithChildren =
  WWorkspaceCampaignsCampaignIdRoute._addFileChildren(
    WWorkspaceCampaignsCampaignIdRouteChildren,
  )

interface WWorkspaceCampaignsRouteChildren {
  WWorkspaceCampaignsCampaignIdRoute: typeof WWorkspaceCampaignsCampaignIdRouteWithChildren
  WWorkspaceCampaignsIndexRoute: typeof WWorkspaceCampaignsIndexRoute
}

const WWorkspaceCampaignsRouteChildren: WWorkspaceCampaignsRouteChildren = {
  WWorkspaceCampaignsCampaignIdRoute:
    WWorkspaceCampaignsCampaignIdRouteWithChildren,
  WWorkspaceCampaignsIndexRoute: WWorkspaceCampaignsIndexRoute,
}

const WWorkspaceCampaignsRouteWithChildren =
  WWorkspaceCampaignsRoute._addFileChildren(WWorkspaceCampaignsRouteChildren)

interface WWorkspaceContactsRouteChildren {
  WWorkspaceContactsContactIdRoute: typeof WWorkspaceContactsContactIdRoute
  WWorkspaceContactsIndexRoute: typeof WWorkspaceContactsIndexRoute
  WWorkspaceContactsSegmentsSegmentIdRoute: typeof WWorkspaceContactsSegmentsSegmentIdRoute
  WWorkspaceContactsSegmentsNewRoute: typeof WWorkspaceContactsSegmentsNewRoute
  WWorkspaceContactsImportIndexRoute: typeof WWorkspaceContactsImportIndexRoute
  WWorkspaceContactsSegmentsIndexRoute: typeof WWorkspaceContactsSegmentsIndexRoute
  WWorkspaceContactsImportImportIdReviewRoute: typeof WWorkspaceContactsImportImportIdReviewRoute
  WWorkspaceContactsImportImportIdIndexRoute: typeof WWorkspaceContactsImportImportIdIndexRoute
}

const WWorkspaceContactsRouteChildren: WWorkspaceContactsRouteChildren = {
  WWorkspaceContactsContactIdRoute: WWorkspaceContactsContactIdRoute,
  WWorkspaceContactsIndexRoute: WWorkspaceContactsIndexRoute,
  WWorkspaceContactsSegmentsSegmentIdRoute:
    WWorkspaceContactsSegmentsSegmentIdRoute,
  WWorkspaceContactsSegmentsNewRoute: WWorkspaceContactsSegmentsNewRoute,
  WWorkspaceContactsImportIndexRoute: WWorkspaceContactsImportIndexRoute,
  WWorkspaceContactsSegmentsIndexRoute: WWorkspaceContactsSegmentsIndexRoute,
  WWorkspaceContactsImportImportIdReviewRoute:
    WWorkspaceContactsImportImportIdReviewRoute,
  WWorkspaceContactsImportImportIdIndexRoute:
    WWorkspaceContactsImportImportIdIndexRoute,
}

const WWorkspaceContactsRouteWithChildren =
  WWorkspaceContactsRoute._addFileChildren(WWorkspaceContactsRouteChildren)

interface WWorkspaceReportsRouteChildren {
  WWorkspaceReportsAutomationsRoute: typeof WWorkspaceReportsAutomationsRoute
  WWorkspaceReportsCampaignsRoute: typeof WWorkspaceReportsCampaignsRoute
  WWorkspaceReportsSupportRoute: typeof WWorkspaceReportsSupportRoute
  WWorkspaceReportsIndexRoute: typeof WWorkspaceReportsIndexRoute
}

const WWorkspaceReportsRouteChildren: WWorkspaceReportsRouteChildren = {
  WWorkspaceReportsAutomationsRoute: WWorkspaceReportsAutomationsRoute,
  WWorkspaceReportsCampaignsRoute: WWorkspaceReportsCampaignsRoute,
  WWorkspaceReportsSupportRoute: WWorkspaceReportsSupportRoute,
  WWorkspaceReportsIndexRoute: WWorkspaceReportsIndexRoute,
}

const WWorkspaceReportsRouteWithChildren =
  WWorkspaceReportsRoute._addFileChildren(WWorkspaceReportsRouteChildren)

interface WWorkspaceSettingsModerationRouteChildren {
  WWorkspaceSettingsModerationRuleIdRoute: typeof WWorkspaceSettingsModerationRuleIdRoute
  WWorkspaceSettingsModerationIndexRoute: typeof WWorkspaceSettingsModerationIndexRoute
}

const WWorkspaceSettingsModerationRouteChildren: WWorkspaceSettingsModerationRouteChildren =
  {
    WWorkspaceSettingsModerationRuleIdRoute:
      WWorkspaceSettingsModerationRuleIdRoute,
    WWorkspaceSettingsModerationIndexRoute:
      WWorkspaceSettingsModerationIndexRoute,
  }

const WWorkspaceSettingsModerationRouteWithChildren =
  WWorkspaceSettingsModerationRoute._addFileChildren(
    WWorkspaceSettingsModerationRouteChildren,
  )

interface WWorkspaceSettingsRouteChildren {
  WWorkspaceSettingsAuditRoute: typeof WWorkspaceSettingsAuditRoute
  WWorkspaceSettingsChannelsRoute: typeof WWorkspaceSettingsChannelsRoute
  WWorkspaceSettingsConsentRoute: typeof WWorkspaceSettingsConsentRoute
  WWorkspaceSettingsFieldsRoute: typeof WWorkspaceSettingsFieldsRoute
  WWorkspaceSettingsGeneralRoute: typeof WWorkspaceSettingsGeneralRoute
  WWorkspaceSettingsModerationRoute: typeof WWorkspaceSettingsModerationRouteWithChildren
  WWorkspaceSettingsProfileRoute: typeof WWorkspaceSettingsProfileRoute
  WWorkspaceSettingsRolesRoute: typeof WWorkspaceSettingsRolesRoute
  WWorkspaceSettingsSavedRepliesRoute: typeof WWorkspaceSettingsSavedRepliesRoute
  WWorkspaceSettingsTeamRoute: typeof WWorkspaceSettingsTeamRoute
  WWorkspaceSettingsIndexRoute: typeof WWorkspaceSettingsIndexRoute
}

const WWorkspaceSettingsRouteChildren: WWorkspaceSettingsRouteChildren = {
  WWorkspaceSettingsAuditRoute: WWorkspaceSettingsAuditRoute,
  WWorkspaceSettingsChannelsRoute: WWorkspaceSettingsChannelsRoute,
  WWorkspaceSettingsConsentRoute: WWorkspaceSettingsConsentRoute,
  WWorkspaceSettingsFieldsRoute: WWorkspaceSettingsFieldsRoute,
  WWorkspaceSettingsGeneralRoute: WWorkspaceSettingsGeneralRoute,
  WWorkspaceSettingsModerationRoute:
    WWorkspaceSettingsModerationRouteWithChildren,
  WWorkspaceSettingsProfileRoute: WWorkspaceSettingsProfileRoute,
  WWorkspaceSettingsRolesRoute: WWorkspaceSettingsRolesRoute,
  WWorkspaceSettingsSavedRepliesRoute: WWorkspaceSettingsSavedRepliesRoute,
  WWorkspaceSettingsTeamRoute: WWorkspaceSettingsTeamRoute,
  WWorkspaceSettingsIndexRoute: WWorkspaceSettingsIndexRoute,
}

const WWorkspaceSettingsRouteWithChildren =
  WWorkspaceSettingsRoute._addFileChildren(WWorkspaceSettingsRouteChildren)

interface WWorkspaceRouteChildren {
  WWorkspaceAutomationsRoute: typeof WWorkspaceAutomationsRouteWithChildren
  WWorkspaceCampaignsRoute: typeof WWorkspaceCampaignsRouteWithChildren
  WWorkspaceCommentsRoute: typeof WWorkspaceCommentsRoute
  WWorkspaceContactsRoute: typeof WWorkspaceContactsRouteWithChildren
  WWorkspaceGettingStartedRoute: typeof WWorkspaceGettingStartedRoute
  WWorkspaceHandoversRoute: typeof WWorkspaceHandoversRoute
  WWorkspaceInboxRoute: typeof WWorkspaceInboxRoute
  WWorkspaceOverviewRoute: typeof WWorkspaceOverviewRoute
  WWorkspaceReportsRoute: typeof WWorkspaceReportsRouteWithChildren
  WWorkspaceSettingsRoute: typeof WWorkspaceSettingsRouteWithChildren
  WWorkspaceIndexRoute: typeof WWorkspaceIndexRoute
  WWorkspaceChannelsConnectionIdRoute: typeof WWorkspaceChannelsConnectionIdRoute
  WWorkspaceChannelsNewRoute: typeof WWorkspaceChannelsNewRoute
  WWorkspaceEnrolConversationIdRoute: typeof WWorkspaceEnrolConversationIdRoute
  WWorkspaceReleaseConversationIdRoute: typeof WWorkspaceReleaseConversationIdRoute
  WWorkspaceChannelsConnectAttemptIdRoute: typeof WWorkspaceChannelsConnectAttemptIdRoute
}

const WWorkspaceRouteChildren: WWorkspaceRouteChildren = {
  WWorkspaceAutomationsRoute: WWorkspaceAutomationsRouteWithChildren,
  WWorkspaceCampaignsRoute: WWorkspaceCampaignsRouteWithChildren,
  WWorkspaceCommentsRoute: WWorkspaceCommentsRoute,
  WWorkspaceContactsRoute: WWorkspaceContactsRouteWithChildren,
  WWorkspaceGettingStartedRoute: WWorkspaceGettingStartedRoute,
  WWorkspaceHandoversRoute: WWorkspaceHandoversRoute,
  WWorkspaceInboxRoute: WWorkspaceInboxRoute,
  WWorkspaceOverviewRoute: WWorkspaceOverviewRoute,
  WWorkspaceReportsRoute: WWorkspaceReportsRouteWithChildren,
  WWorkspaceSettingsRoute: WWorkspaceSettingsRouteWithChildren,
  WWorkspaceIndexRoute: WWorkspaceIndexRoute,
  WWorkspaceChannelsConnectionIdRoute: WWorkspaceChannelsConnectionIdRoute,
  WWorkspaceChannelsNewRoute: WWorkspaceChannelsNewRoute,
  WWorkspaceEnrolConversationIdRoute: WWorkspaceEnrolConversationIdRoute,
  WWorkspaceReleaseConversationIdRoute: WWorkspaceReleaseConversationIdRoute,
  WWorkspaceChannelsConnectAttemptIdRoute:
    WWorkspaceChannelsConnectAttemptIdRoute,
}

const WWorkspaceRouteWithChildren = WWorkspaceRoute._addFileChildren(
  WWorkspaceRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CreateWorkspaceRoute: CreateWorkspaceRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  PrivacyRoute: PrivacyRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignInRoute: SignInRoute,
  TermsRoute: TermsRoute,
  InviteTokenRoute: InviteTokenRoute,
  WWorkspaceRoute: WWorkspaceRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
